import React, { useEffect, useState } from 'react';
import { Button, Box, Text, Flex, Image, useColorModeValue } from '@chakra-ui/react';

function InstallPWAButton() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [isIos, setIsIos] = useState(false);
  const [showIosMessage, setShowIosMessage] = useState(false);

  const bgCard = useColorModeValue('gray.100', 'gray.700');
  const textColor = useColorModeValue('gray.800', 'gray.200');

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const ios = /iphone|ipad|ipod/.test(userAgent);
    const inStandalone = window.matchMedia('(display-mode: standalone)').matches;

    setIsIos(ios);

    if (ios && !inStandalone) {
      setShowIosMessage(true);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`Usuário escolheu: ${outcome}`);
    setDeferredPrompt(null);
    setShowInstallButton(false);
  };

  return (
    <Flex direction="column" align="center" mt={6}>
      {showInstallButton && (
        <Button
          colorScheme="blue"
          size="md"
          borderRadius="md"
          onClick={handleInstallClick}
          mb={4}
        >
          Instalar Aplicativo
        </Button>
      )}

        {isIos && showIosMessage && (
        <Box
          bg={bgCard}
          borderRadius="lg"
          p={4}
          maxW="320px"
          textAlign="left"
          boxShadow="md"
        >
          <Text fontSize="sm" color={textColor}>
            Para instalar este app no seu iPhone ou iPad:
          </Text>
          <Text fontSize="sm" color={textColor} mt={2}>
            1️⃣ Toque em{' '}
            <strong>Compartilhar</strong>
          </Text>
          <Text fontSize="sm" color={textColor}>
            2️⃣ Depois escolha <strong>“Adicionar à Tela de Início”</strong>.
          </Text>
        </Box>
      )}
    </Flex>
  );
}

export default InstallPWAButton;
